<div class="service-catalog-search">
  <div id="search-service" class="search-service">
    <div id="service-catalog-2" class="flex-grow-1">
      <dx-select-box
        [dataSource]="this.searchDataSource"
        [(value)]="this.selectedSearchResult"
        displayExpr="nameUa"
        placeholder="{{ 'SEARCH_IT_SERVICE' | translate }}"
        [minSearchLength]="0"
        [searchEnabled]="true"
        [searchTimeout]="500"
        [openOnFieldClick]="false"
        openOnFieldClick="false"
        animationEnabled="false"
        id="searchDataSourceId"
        (onFocusIn)="this.onFocusIn()"
        (onInput)="this.onInput()"
        (onFocusOut)="this.onFocusOut($event)"
        (onSelectionChanged)="this.onFocusOut($event)"
        (onItemClick)="this.selectService($event)"
        class="search-dx-select-box search-dx-select-box-fullscreen mdi mdi-magnify">
        <div *dxTemplate="let entity of 'item'" class="custom-item catalog-photo" style="white-space: pre-wrap">
          @if (entity.type == 'self-diagnosis') {
            <div class="d-flex">
              <div class="me-3">
                @if (entity.iconBody) {
                  <img [src]="this.sanitizer.bypassSecurityTrustResourceUrl('data:' + entity.iconType + ';base64,' + entity.iconBody)" />
                }
                @if (!entity.iconBody) {
                  <img src="../../../../../assets/images/nophoto.png" />
                }
              </div>
              <div>
                <div>{{ entity.nameUa }}</div>
                <div class="category color-black" style="font-size: 80%; color: #091e42">
                  {{ entity.description }}
                </div>
              </div>
            </div>
          }

          @if (entity.type == 'service') {
            <div class="d-flex">
              <div class="me-3">
                @if (entity.category.iconBody) {
                  <img
                    [src]="
                      this.sanitizer.bypassSecurityTrustResourceUrl(
                        'data:' + entity.category.iconType + ';base64,' + entity.category.iconBody
                      )
                    " />
                }
                @if (!entity.category.iconBody) {
                  <img src="../../../../../assets/images/nophoto.png" />
                }
              </div>
              <div>
                <div>{{ this.isUkLanguage ? entity.nameUa : entity.nameRu }}</div>
                <div class="category color-black" style="font-size: 80%; color: #091e42">
                  {{ this.isUkLanguage ? entity.category.nameUa : entity.category.nameRu }}
                </div>
              </div>
            </div>
          }
        </div>
      </dx-select-box>
    </div>
  </div>
</div>
